{
  "possibleTypes": {
    "AF_AnswersStatisticsInterface": [
      "AnswersStatistics",
      "MatrixAnswersStatistics"
    ],
    "AF_FormItem": [
      "AF_FormItemCategory",
      "AF_FormItemClassroom",
      "AF_FormItemDate",
      "AF_FormItemEmail",
      "AF_FormItemFile",
      "AF_FormItemMatrix",
      "AF_FormItemMoreInformation",
      "AF_FormItemMultiSelect",
      "AF_FormItemMultilineText",
      "AF_FormItemNumber",
      "AF_FormItemOrganizationalUnit",
      "AF_FormItemPhoneNumber",
      "AF_FormItemRating",
      "AF_FormItemScale",
      "AF_FormItemSelect",
      "AF_FormItemSenderName",
      "AF_FormItemSimpleText"
    ],
    "AF_FormItemAnswer": [
      "AF_FormItemAnswerFile",
      "AF_FormItemAnswerMatrix",
      "AF_FormItemAnswerWithOptions",
      "AF_FormItemAnswerWithValues"
    ],
    "AF_FormItemAnswerInterface": [
      "AF_FormItemAnswerFile",
      "AF_FormItemAnswerMatrix",
      "AF_FormItemAnswerWithOptions",
      "AF_FormItemAnswerWithValues"
    ],
    "AF_FormItemInterface": [
      "AF_FormItemCategory",
      "AF_FormItemClassroom",
      "AF_FormItemDate",
      "AF_FormItemEmail",
      "AF_FormItemFile",
      "AF_FormItemMatrix",
      "AF_FormItemMoreInformation",
      "AF_FormItemMultiSelect",
      "AF_FormItemMultilineText",
      "AF_FormItemNumber",
      "AF_FormItemOrganizationalUnit",
      "AF_FormItemPhoneNumber",
      "AF_FormItemRating",
      "AF_FormItemScale",
      "AF_FormItemSelect",
      "AF_FormItemSenderName",
      "AF_FormItemSimpleText"
    ],
    "AF_FormItemWithOptionsInterface": [
      "AF_FormItemCategory",
      "AF_FormItemMultiSelect",
      "AF_FormItemOrganizationalUnit",
      "AF_FormItemRating",
      "AF_FormItemScale",
      "AF_FormItemSelect"
    ],
    "AF_FormItemWithOptionsWithOtherInterface": [
      "AF_FormItemMultiSelect",
      "AF_FormItemSelect"
    ],
    "BackgroundProcessTriggeredBy": [
      "BackgroundProcessSystemTrigger",
      "Member"
    ],
    "CaseInterface": [
      "CompanyReport",
      "Submission"
    ],
    "CompanyReportAuditLog": [
      "CompanyReportAuditLogType_default",
      "CompanyReportAuditLogType_editFormItemAnswer"
    ],
    "CompanyReportAuditLogBase": [
      "CompanyReportAuditLogType_default",
      "CompanyReportAuditLogType_editFormItemAnswer"
    ],
    "CompanyReportFollowUpCommentAuthor": [
      "CompanyVictim",
      "Member"
    ],
    "CreditTopUpResult": [
      "TopUpHotlineCreditsInvoice",
      "TopUpHotlineCreditsUrl"
    ],
    "InstitutionInterface": [
      "Company"
    ],
    "PublicUserInterface": [
      "Member"
    ],
    "RegisteredUserInterface": [
      "Member"
    ],
    "ReportSourceConfiguration": [
      "AiHotlineReportSourceConfiguration",
      "AutomatedHotlineReportSourceConfiguration",
      "FormReportSourceConfiguration",
      "LiveHotlineReportSourceConfiguration"
    ],
    "UserInterface": [
      "FuAdmin",
      "Member"
    ]
  }
}